<mat-sidenav-container class="layout" autosize>
  <mat-sidenav
    #drawer
    [mode]="isMobile() ? 'over' : 'side'"
    [disableClose]="!isMobile()"
    class="sidenav"
  >
    <div class="logo">BACKOFFICE</div>
    <br>
    @if (userFullName()) {
      <div class="texto-usuario">Hola, {{ userFullName() }}</div>
    }
    @if (roleLabel()) {
      <div class="texto-usuario line-separator">Rol: {{ roleLabel() }}</div>
    }

    <nav>
      <ng-container *ngFor="let item of filteredMenu()">
          <div class="menu-item" (click)="item.children ? toggleGroup(item.label) : navigate(item)">
            <mat-icon>{{ item.icon }}</mat-icon>
            <span>{{ item.label }}</span>
            <mat-icon *ngIf="item.children">
              {{ isOpen(item.label) ? 'expand_less' : 'expand_more' }}
            </mat-icon>
          </div>

          <div class="submenu" *ngIf="item.children && isOpen(item.label)">
            <div class="submenu-item" *ngFor="let child of visibleChildren(item)" (click)="navigate(child)">
              {{ child.label }}
            </div>
          </div>
      </ng-container>
    </nav>
  </mat-sidenav>

  <mat-sidenav-content>
    <button mat-icon-button class="menu-btn" *ngIf="isMobile()" (click)="toggleSidebar()">
      <mat-icon>menu</mat-icon>
    </button>

    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
